import styles from './Overview.module.scss';
import { useState, useEffect } from 'react';

import DateNavigation from '../../../utils/DateNavigation/DateNavigation';

import { getVisitsByPeriod, getSignupsByPeriod, getNbGamesByPeriod, getNbVillagesByPeriod, getNbGamesAchievedByPeriod, getNbVillagesAchievedByPeriod } from '../../../utils/api/insightsAPI';

const debug = true;

const Overview = () => {
  const [period, setPeriod] = useState('week');
  const [date, setDate] = useState(new Date());
  const [dateRange, setDateRange] = useState("");

  const [visits, setVisits] = useState({ currentPeriod: 0, previousPeriod: 0, variation: 0 });
  const [signups, setSignups] = useState({ currentPeriod: 0, previousPeriod: 0, variation: 0 });
  const [gamesStarts, setGamesStarts] = useState({ currentPeriod: 0, previousPeriod: 0, variation: 0 });
  const [villagesStarts, setVillagesStarts] = useState({ currentPeriod: 0, previousPeriod: 0, variation: 0 });
  const [gamesAchieved, setGamesAchieved] = useState({ currentPeriod: 0, previousPeriod: 0, variation: 0 });
  const [villagesAchieved, setVillagesAchieved] = useState({ currentPeriod: 0, previousPeriod: 0, variation: 0 });


  useEffect(() => {
    const fetchData = async () => {
      const visitsData = await getVisitsByPeriod(period, date);
      setVisits({ currentPeriod: visitsData.currentPeriod, previousPeriod: visitsData.previousPeriod, variation : visitsData.variation });
      const signupsData = await getSignupsByPeriod(period, date);
      setSignups({ currentPeriod: signupsData.currentPeriod, previousPeriod: signupsData.previousPeriod, variation : signupsData.variation });
      const gamesStartsData = await getNbGamesByPeriod(period, date);
      setGamesStarts({ currentPeriod: gamesStartsData.currentPeriod, previousPeriod: gamesStartsData.previousPeriod, variation : gamesStartsData.variation });
      const villagesStartsData = await getNbVillagesByPeriod(period, date);
      setVillagesStarts({ currentPeriod: villagesStartsData.currentPeriod, previousPeriod: villagesStartsData.previousPeriod, variation : villagesStartsData.variation });
      const gamesAchievedData = await getNbGamesAchievedByPeriod(period, date);
      setGamesAchieved({ currentPeriod: gamesAchievedData.currentPeriod, previousPeriod: gamesAchievedData.previousPeriod, variation : gamesAchievedData.variation });
      const villagesAchievedData = await getNbVillagesAchievedByPeriod(period, date);
      setVillagesAchieved({ currentPeriod: villagesAchievedData.currentPeriod, previousPeriod: villagesAchievedData.previousPeriod, variation : villagesAchievedData.variation });
    };

    if (debug) console.log(gamesStarts);

    fetchData();
  }, [period, date.getTime()]);


  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>Vue d'ensemble</h2>
        <p>({dateRange})</p>
      </div>

      <DateNavigation period={period} setPeriod={setPeriod} date={date} setDate={setDate} setDateRange={setDateRange} />

      <div className={styles.cards}>
        {/* Total Players */}
        <div className={styles.card}>
          <div className={styles.cardText}>
            <p className={styles.label}>Nombre de visiteurs uniques</p>
            <h3>{visits.currentPeriod.toLocaleString()}</h3>
            <p className={visits.variation > 0 ? styles.variationUp : styles.variationDown}>
              {visits.variation > 0 ? '+' : visits.variation < 0 ? '-' : ''} {Math.abs(visits.variation)}% 
            </p>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardText}>
            <p className={styles.label}>Nombre de nouveaux inscrits</p>
            <h3>{signups.currentPeriod.toLocaleString()}</h3>
            <p className={signups.variation > 0 ? styles.variationUp : styles.variationDown}>
              {signups.variation > 0 ? '+' : signups.variation < 0 ? '-' : ''} {Math.abs(signups.variation)}% 
            </p>
          </div>
        </div>

        {/* Games by type */}
        <div className={styles.card}>
          <div className={styles.cardText}>
            <p className={styles.label}>Total parties actives (démarrées)</p>
            <h3>{(gamesStarts.currentPeriod + villagesStarts.currentPeriod).toLocaleString()}</h3>
            <ul className={styles.subList}>
              <li>Villages — {villagesStarts.currentPeriod}</li>
              <li>Insolite — {gamesStarts.currentPeriod}</li>
            </ul>
          </div>
        </div>

        {/* Completion rates */}
        <div className={styles.card}>
          <div className={styles.cardText}>
            <p className={styles.label}>Total parties terminées</p>
            <h3>{(gamesAchieved.currentPeriod + villagesAchieved.currentPeriod).toLocaleString()}</h3>
            <ul className={styles.subList}>
              <li>Villages — {villagesAchieved.currentPeriod}</li>
              <li>Insolite — {gamesAchieved.currentPeriod}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
